module.exports = __webpack_public_path__ + "static/media/desktopScreenshot01.db74fe14.jpg";